import { Menu } from "antd";
import { useTranslation } from "react-i18next";
import { IoCardOutline, IoPricetagOutline, IoWalletOutline } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom"; // Import Link and useLocation
import { useAuthManager } from "../../hooks/useAuthManager";

const Sidebar = ({ collapsed }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { logout } = useAuthManager();

  const handleLogout = () => {
    logout();
  };

  // Define your route links for each menu item
  const items = [
    {
      key: "home",
      icon: <img src="/assets/images/icons/nav/home.png" alt="" />,
      label: <Link to="/home">{t("sideNav.home")}</Link>,
      path: "/home",
      match: ["/home"],
    },
    {
      key: "user-accounts",
      icon: <img src="/assets/images/icons/nav/user-acc.png" alt="" />,
      label: <Link to="/user-accounts">User Accounts</Link>,
      path: "/user-accounts",
      match: ["/user-accounts"],
    },
    {
      key: "accounts",
      icon: <img src="/assets/images/icons/nav/business-acc.png" alt="" />,
      label: <Link to="/accounts">Business Accounts</Link>,
      path: "/accounts",
      match: ["/accounts"],
    },
    {
      key: "features",
      icon: <img src="/assets/images/icons/nav/business-features.png" alt="" />,
      label: <Link to="/features">Business Features</Link>,
      path: "/features",
      match: ["/features"],
    },
    {
      key: "campaigns",
      icon: <img src="/assets/images/icons/nav/campaign.png" alt="" />,
      label: <Link to="/campaigns">{t("sideNav.campaigns")}</Link>,
      path: "/campaigns",
      match: ["/campaigns"],
    },
    {
      key: "stamp-cards",
      icon: <img src="/assets/images/icons/nav/stamp-card.png" alt="" />,
      label: <Link to="/stamp-cards">Stamp Cards</Link>,
      path: "/stamp-cards",
      match: ["/stamp-cards"],
    },
    {
      key: "payouts",
      icon: <IoWalletOutline size={16} />,
      label: <Link to="/payouts">Payouts</Link>,
      path: "/payouts",
      match: ["/payouts"], // ✅ important for deep routes
    },
    {
      key: "subscriptions",
      icon: <IoCardOutline size={16} />,
      label: <Link to="/subscriptions">Subscriptions</Link>,
      path: "/subscriptions",
      match: ["/subscriptions"],
    },
    {
      key: "promo-codes",
      icon: <IoPricetagOutline size={16} />,
      label: <Link to="/promo-codes">Promo Codes</Link>,
      path: "/promo-codes",
      match: ["/promo-codes"],
    },
    {
      key: "outlets",
      icon: <img src="/assets/images/icons/nav/outlet.png" alt="" />,
      label: <Link to="/outlets">Outlets</Link>,
      path: "/outlets",
      match: ["/outlets"],
    },
    {
      key: "journal",
      icon: <img src="/assets/images/icons/nav/journal.png" alt="" />,
      label: <Link to="/journal">Journal</Link>,
      path: "/journal",
      match: ["/journal"],
    },

    { type: "divider" },

    {
      key: "settings",
      icon: <img src="/assets/images/icons/nav/settings.png" alt="" />,
      label: <Link to="/settings">{t("sideNav.settings")}</Link>,
      path: "/settings",
      match: ["/settings"],
    },
    {
      key: "logout",
      icon: (
        <img
          className="my-svg"
          src="/assets/images/icons/nav/sign-out.png"
          alt=""
        />
      ),
      label: <Link onClick={handleLogout}>{t("sideNav.logout")}</Link>,
    },
  ];

  // Dynamically set the selected key based on the current path
  const selectedKey = items
    .filter((item) => {
      if (!item.match) return false;
      return item.match.some((path) =>
        new RegExp(`(^|/)${path.replace("/", "")}(/|$)`).test(
          location.pathname,
        ),
      );
    })
    .map((item) => item.key);

  return (
    <>
      <Menu
        className="sidebar"
        selectedKeys={selectedKey} // Set selected key dynamically
        mode="inline"
        inlineCollapsed={collapsed}
        items={items} // Directly pass the items here
      />
    </>
  );
};

export default Sidebar;
